"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * IngredientConverter.
 *
 * @author Adam Drda
 */


var IngredientConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(IngredientConverter, _DataObjectConverter_);

  function IngredientConverter() {
    _classCallCheck(this, IngredientConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(IngredientConverter).apply(this, arguments));
  }

  return IngredientConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.IngredientConverter = IngredientConverter;